import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { VinInfo } from '../models';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
@ApiService({ baseName: 'vin' })
export class VinInfoApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  public static fromJSON<T extends VinInfo>(vinInfo: any): T {
    return { ...vinInfo };
  }

  getInfo(vin: string): Observable<VinInfo> {
    return this.http.get(this.getUrl(vin)).pipe(
      map((res) => {
        return VinInfoApiService.fromJSON<VinInfo>(res);
      }),
    );
  }
}
